import { useFieldContext, useFieldValue, useIsFieldOptional } from './shared';
import { useFormReadOnly } from './form-read-only';
import { FieldLabelRow } from './field-label-row';
import { DocumentUpload } from './-components/document-upload';

/**
 * Form field for document uploads. The field value encodes three states:
 * - `undefined` = no change (keep existing server document)
 * - `File` = new file uploaded
 * - `''` = existing document removed
 */
export default function DocumentUploadField(props: {
	currentUrl: string | undefined;
	currentKey: string | undefined;
	buttonLabel: string;
	label?: string;
	noFileText?: string;
	fallbackFileName?: string;
	downloadText?: string;
	removeFileText?: string;
	dropZoneDescription?: string;
}) {
	const field = useFieldContext<File | '' | undefined>();
	const formReadOnly = useFormReadOnly();
	const isOptional = useIsFieldOptional(field.name);
	const value = useFieldValue(field);
	const isRemoved = value === '';

	return (
		<div>
			{props.label && (
				<div className="mb-2">
					<FieldLabelRow
						label={props.label}
						htmlFor={field.name}
						hasError={field.state.meta.isTouched && !field.state.meta.isValid}
						optional={isOptional}
					/>
				</div>
			)}
			<DocumentUpload
				id={field.name}
				currentUrl={isRemoved ? undefined : props.currentUrl}
				currentKey={isRemoved ? undefined : props.currentKey}
				file={value instanceof File ? value : undefined}
				onChange={(file) => field.handleChange(file)}
				onRemove={() => field.handleChange('')}
				label={props.buttonLabel}
				readOnly={formReadOnly}
				noFileText={props.noFileText}
				fallbackFileName={props.fallbackFileName}
				downloadText={props.downloadText}
				removeFileText={props.removeFileText}
				dropZoneDescription={props.dropZoneDescription}
			/>
		</div>
	);
}
